import classNames from 'classnames'
import { OpenInWindow } from 'iconoir-react'

type LearnMoreLinkProps = {
  to: string
  children: React.ReactNode
  className?: string
}

function extractIntercomArticleId(url: string): string | null {
  const match = url.match(/\/articles\/(\d+)/)
  return match ? match[1] : null
}

export function LearnMoreLink({ to, children, className }: LearnMoreLinkProps) {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault()

    // Check if this is an Intercom help article URL
    if (to.includes(`intercom.help`)) {
      const articleId = extractIntercomArticleId(to)
      if (articleId && window.Intercom) {
        window.Intercom(`showArticle`, articleId)
        return
      }
    }

    // Fallback to opening in new window
    window.open(to, `_blank`, `noreferrer`)
  }

  return (
    <button
      onClick={handleClick}
      className={classNames(`flex cursor-pointer items-end text-label-xs text-primary-600`, className)}
    >
      <OpenInWindow className="mb-0.5 mr-1" width={12} height={12} />
      {children}
    </button>
  )
}
